import { AxiosResponse } from "axios";
import httpClient from "../../api/httpClient";
import AcompanhamentoEntregaMateriaPrima from "../classes/AcompanhamentoEntregaMateriaPrima";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  {
    method: "GET",
    rota: "AcompanhamentoMateriaPrima/All/RecuperarPorFiltro",
  },
  { method: "POST", rota: "AcompanhamentoMateriaPrima/Adicionar" },
  { method: "PUT", rota: "AcompanhamentoMateriaPrima/AtualizarLote" },
  { method: "DELETE", rota: "AcompanhamentoMateriaPrima/Apagar" },
];

const cacheKey: string = "AcompanhamentoMateriaPrimaCache";
const cacheKeySelC: string = "AcompanhamentoMateriaPrimaSelecionado";

const apiServico: string = "PEDIDOS";

export default class AcompanhamentoEntregaMateriaPrimaDataset extends httpClient {
  constructor() {
    super(apiServico);
  }

  async getAll(): Promise<AcompanhamentoEntregaMateriaPrima[]> {
    let ok: boolean = false;
    let data: AcompanhamentoEntregaMateriaPrima[] = [];
    let error: any = undefined;
    await super
      .Get(calls[0].rota)
      .then((response: AxiosResponse) => {
        ok = response.status == 200;
        data = AcompanhamentoEntregaMateriaPrima.fromJson(response.data);
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<AcompanhamentoEntregaMateriaPrima[]>((resolve) => {
      resolve(data);
    });
  }

  async add(value: AcompanhamentoEntregaMateriaPrima) {
    let ok: boolean = false;
    let error: any = undefined;
    super
      .post(calls[1].rota, value)
      .then((result) => {
        ok = JSON.parse(result);
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
  }

  async update(values: object): Promise<boolean> {
    let error: any = undefined;
    return super
      .put(calls[2].rota, values)
      .then((response: AxiosResponse) => {
        return true;
      })
      .catch((erro) => {
        error = erro;
        console.error(erro);
        if (error !== undefined) throw error;
        return false;
      });
  }

  async remove(value: AcompanhamentoEntregaMateriaPrima): Promise<boolean> {
    let ok: boolean = false;
    let error: any = undefined;
    await super
      .delete(calls[3].rota, AcompanhamentoEntregaMateriaPrima.toJson(value))
      .then((response: AxiosResponse) => {
        ok = response.status == 200;
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<boolean>((resolve) => {
      resolve(ok);
    });
  }

  getKeyCache(): string {
    return cacheKey;
  }

  getKeyCacheSelected(): string {
    return cacheKeySelC;
  }

  getAllFromCache(): AcompanhamentoEntregaMateriaPrima[] {
    let result: AcompanhamentoEntregaMateriaPrima[] = JSON.parse(cacheKey);
    return result;
  }

  addResultsToCache(value: AcompanhamentoEntregaMateriaPrima[]) {
    localStorage.setItem(cacheKey, JSON.stringify(value));
  }

  clearCache() {
    localStorage.removeItem(cacheKey);
  }

  clearSelectedItemFromCache() {
    localStorage.removeItem(cacheKeySelC);
  }
}
